import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { BazowyComponent } from '../../../bazowy.component';
import { RaportGodzinowy } from '../raporty-godzinowe-edycja.component';

@Component({
  selector: 'app-dodaj-godziny-modal',
  templateUrl: './dodaj-godziny-modal.component.html',
  styleUrls: ['./dodaj-godziny-modal.component.css'],
})
export class DodajGodzinyModalComponent
  extends BazowyComponent
  implements OnInit
{
  // Dane przekazane z rodzica
  pracownicy: { id: string; nazwa: string }[] = [];
  projekty: { id: string; nazwa: string }[] = [];
  istniejaceWpisy: RaportGodzinowy[] = [];

  // Model formularza
  wybranyPracownikId: string = null;
  wybranyProjektId: string = null;
  data: string = '';
  godziny: number = 8;

  // Flaga potwierdzenia nadpisania
  czyPokazacPotwierdzenie: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public router: Router,
    modalService: NgbModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public translateSerwis: TranslateService
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    // Ustaw domyślną datę na dziś
    this.data = new Date().toISOString().split('T')[0];
  }

  zapisz(): void {
    // Walidacja
    if (
      !this.wybranyPracownikId ||
      !this.wybranyProjektId ||
      !this.data ||
      this.godziny === null
    ) {
      this.wyswietlKomunikat('Wypełnij wszystkie pola', true);
      return;
    }

    // Sprawdź czy wpis już istnieje
    const istnieje = this.sprawdzCzyWpisIstnieje();

    if (istnieje && !this.czyPokazacPotwierdzenie) {
      this.czyPokazacPotwierdzenie = true;
      return; // Pokaż komunikat potwierdzenia
    }

    // Zamknij modal z danymi
    this.activeModal.close({
      pracownikId: this.wybranyPracownikId,
      projektId: this.wybranyProjektId,
      data: this.data,
      godziny: this.godziny,
    });
  }

  sprawdzCzyWpisIstnieje(): boolean {
    return this.istniejaceWpisy.some(
      (raport) =>
        raport.pracownikId === this.wybranyPracownikId &&
        raport.godzinyDni.some((d) => d.data === this.data)
    );
  }

  anuluj(): void {
    this.activeModal.dismiss();
  }

  anulujPotwierdzenie(): void {
    this.czyPokazacPotwierdzenie = false;
  }
}
